import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTTile {
    /* @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }
}

export const TFTTileConfiguration = {
    template,
    bindings: {
        label: '<',
    },
    controller: TFTTile,
    controllerAs: 'tileCtrl'
};

angular.module('TALENYA-FE').component('tftTile', TFTTileConfiguration);
